import { leaderboard, challenges } from "../data";

const initialState = {
  isLoggedIn: false,
  scores: null,
  goals: null,
  userID: null,
  userStats: null,
  lastDateScoreWasAdded: null,
  leaderboard,
  challenges,
};

const initialStats = {
  currentStreak: 0,
  longestStreak: 0,
  currentLeague: "bronze",
  challengesCompleted: 0,
  XP: 100,
  coins: 20,
};

const testStats = {
  currentStreak: 6,
  longestStreak: 10,
  currentLeague: "bronze",
  challengesCompleted: 2,
  XP: 320,
  coins: 100,
};

function reducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      localStorage?.setItem("userID", JSON.stringify(action.payload.userID));
      localStorage?.setItem("token", JSON.stringify(action.payload.token));
      localStorage?.setItem("isLoggedIn", JSON.stringify(true));
      return {
        ...state,
        scores: action.payload.scores,
        goals: action.payload.goals,
        userID: action.payload.userID,
        lastDateScoreWasAdded: "2022-05-09T00:00:00.000+00:00",
        userStats: testStats,
        isLoggedIn: true,
        leaderboard,
        challenges,
      };
    case "SIGNUP":
      localStorage?.setItem("userID", JSON.stringify(action.payload.userID));
      localStorage?.setItem("token", JSON.stringify(action.payload.token));
      localStorage?.setItem("isLoggedIn", JSON.stringify(true));
      return {
        ...state,
        userID: action.payload.userID,
        userStats: initialStats,
        isLoggedIn: true,
        leaderboard,
        challenges,
      };
    case "LOGOUT":
      localStorage?.removeItem("userID");
      localStorage?.removeItem("token");
      localStorage?.setItem("isLoggedIn", JSON.stringify(false));
      return { ...initialState };
    case "SETGOALS":
      return { ...state, goals: action.payload };
    case "ADDSCORE":
      return {
        ...state,
        scores: state.scores.map((userScore) => {
          if (userScore.userID === action.payload.userID) {
            userScore.scores.push(action.payload.scores);
          }
        }),
      };
    case "UPDATE_LAST_DATE_SCORE_WAS_ADDED":
      return {
        ...state,
        lastDateScoreWasAdded: action.payload,
      };
    case "JOIN_CHALLENGE":
      return {
        ...state,
        challenges: state.challenges.map((challenge) => {
          if (challenge.id === action.payload.challengeID) {
            challenge.participants.push({
              userID: action.payload.userID,
            });
            return {
              ...challenge,
            };
          } else {
            return challenge;
          }
        }),
        userStats: {
          ...state.userStats,
          coins: state.userStats.coins - action.payload.coinsBet,
        },
      };
    default:
      throw new Error();
  }
}

export { reducer, initialState };
